import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip } from "recharts";
import { CalendarPlus } from "lucide-react";
import { Panel } from "@/components/common";
import { useFetch } from "@/hooks/useFetch";
import { fmtDate } from "@/lib/format";

const Tile = ({ label, value, testId }) => (
  <div className="rounded-lg border border-slate-200 bg-white px-4 py-3" data-testid={testId}>
    <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">{label}</div>
    <div className="font-display text-2xl font-bold text-[#0E1E38]">{value ?? "–"}</div>
  </div>
);

export const IntakeStats = ({ today }) => {
  const { data } = useFetch("/dashboard/intake", { today });
  const daily = (data?.daily || []).map((d) => ({ ...d, label: fmtDate(d.date, "d MMM") }));
  return (
    <div data-testid="intake-stats">
    <Panel title={<span className="inline-flex items-center gap-2"><CalendarPlus className="h-4 w-4 text-[#0E1E38]" /> New bookings entered (by date created)</span>} id="intake-stats">
      <div className="mb-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
        <Tile label="Today" value={data?.today} testId="intake-today" />
        <Tile label="Yesterday" value={data?.yesterday} testId="intake-yesterday" />
        <Tile label="This week" value={data?.this_week} testId="intake-week" />
        <Tile label="This month" value={data?.this_month} testId="intake-month" />
      </div>
      <div className="h-44 w-full" data-testid="intake-chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={daily} margin={{ top: 4, right: 4, left: -24, bottom: 0 }}>
            <XAxis dataKey="label" tick={{ fontSize: 10 }} interval={4} tickLine={false} axisLine={{ stroke: "#E2E8F0" }} />
            <YAxis allowDecimals={false} tick={{ fontSize: 10 }} tickLine={false} axisLine={false} />
            <Tooltip cursor={{ fill: "#F1F5F9" }} formatter={(v) => [v, "Bookings entered"]} labelFormatter={(l) => l} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
            <Bar dataKey="count" fill="#0E1E38" radius={[3, 3, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <p className="mt-2 text-xs text-slate-500">Last 30 days · counts the day a booking was entered into the system, not the moving date.</p>
    </Panel>
    </div>
  );
};
